import { Formik, Form, Field, ErrorMessage, FieldArray } from 'formik';
import React, { Fragment } from 'react'
import { useEffect } from 'react';
import { withRouter } from 'react-router-dom'
import estilos from '../Tabs/TabsInspeccionarComponent.module.css'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Typography } from '@mui/material';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';

import { useContext } from 'react';
import InspectorEnCampoContext from '../../Context/InspectorEnCampoContext';
import { getTipoEquipoByIdArea } from '../../../../redux/DucksUnidadInspeccion/TipoEquipoDuck';
import { getElementoSeccionByIdArea } from '../../../../redux/DucksUnidadInspeccion/ElementoSeccionDuck';
import { getProcesoByIdArea } from '../../../../redux/DucksUnidadInspeccion/ProcesosDuck';
import { insertFi25Procesos } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoProcesosDuck';
import { insertEquipoHistorial } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoEquipoHistorial';
import { insertDataElementoClienteHistorial } from '../../../../redux/DucksUnidadInspeccion/DataElementoClienteHistorialDuck';
import { getanexoByIdInforme } from '../../../../redux/DucksUnidadInspeccion/Fi25anexoDuck';
import { insertSuperficie } from '../../../../redux/DucksUnidadInspeccion/SuperficieDuck';

import { ReactNotifications } from 'react-notifications-component'
import { Store } from 'react-notifications-component';
import 'react-notifications-component/dist/theme.css'

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 1300,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

function MoliendaFormComponent(props) {

    const dispatch = useDispatch();

    const { moliendaContext, setContextMolienda } = useContext(InspectorEnCampoContext);

    const [isContext, setIsContext] = React.useState(false);

    const tipoequipo = useSelector(store => store.ElementoSeccion.ElementoSeccion);
    const procesos = useSelector(store => store.Procesos.Proceso);

    const todo = props.detalles;
    const idinforme = props.idinforme;
    const idanexo = useSelector(store => store.anexo.anexo);
    const instalacion = props.instalacion - 1;

    const [equipoMolienda, setequipoMolienda] = React.useState([]);
    const [procesosMolienda, setProcesosMolienda] = React.useState([]);

    const [initialValues, setInitialValues] = React.useState({
        equipoMolienda: equipoMolienda,
        procesosMolienda: procesosMolienda
    })


    const [informacionFormikModal, setInformacionFormikModal] = React.useState(
        {
            tipo: '',
            cantidad: '',
            capacidad: '',
            descripcion: '',
            condicion: '',
            largo: '',
            ancho: '',
            area: ''
        }
    );



    const [openModalNuevoEquipo, setOpenModalNuevoEquipo] = React.useState(false);
    const [editarEquipo, setEditarEquipo] = React.useState(true);


    useEffect(() => {

        //dispatch(getTipoEquipoByIdArea(2))
        dispatch(getElementoSeccionByIdArea(2))
        dispatch(getProcesoByIdArea(2))
        // if (idinforme?.idfi_25_informecumplimientonom) {
        //     dispatch(getanexoByIdInforme(idinforme.idfi_25_informecumplimientonom)) //informe
        // }

        if (moliendaContext != null) {
            setequipoMolienda(moliendaContext.equipoMolienda)
            setIsContext(true)
        } else {
            todo.anexocliente[instalacion].dataelementocliente.map((equipo, index) => {
                if (equipo.idseccion === 2) {

                    let capacidad = parseInt(equipo.descripcion)

                    if (isNaN(capacidad)) {
                        setequipoMolienda([...equipoMolienda, {
                            cantidad: equipo.cantidad,
                            descripcion: equipo.descripcion,
                            elemento: {
                                idelemento: equipo.elemento.idelemento,
                                nombreelemento: equipo.elemento.nombreelemento
                            },
                            idanexocliente: equipo.idanexocliente,
                            iddataelementocliente: equipo.iddataelementocliente,
                            idelemento: equipo.idelemento,
                            idseccion: equipo.idseccion,
                            otro: equipo.otro
                        }])
                    } else {
                        setequipoMolienda([...equipoMolienda, {
                            cantidad: equipo.cantidad,
                            descripcion: "",
                            capacidad: equipo.descripcion,
                            elemento: {
                                idelemento: equipo.elemento.idelemento,
                                nombreelemento: equipo.elemento.nombreelemento
                            },
                            idanexocliente: equipo.idanexocliente,
                            iddataelementocliente: equipo.iddataelementocliente,
                            idelemento: equipo.idelemento,
                            idseccion: equipo.idseccion,
                            otro: equipo.otro
                        }])
                    }
                }
            })
        }

    }, [todo])

    useEffect(() => {
        procesos.forEach(element => {
            if (element.idseccion == 2) {
                procesosMolienda.push(element)
            }
        })
    }, [procesos])

    useEffect(() => {
        procesosMolienda
    }, [procesosMolienda])

    const handleModificar = () => {
        setEditarEquipo(!editarEquipo);
    }

    const handleOpenModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(true);
    }
    const handleCloseModalNuevoEquipo = () => {
        setOpenModalNuevoEquipo(false);
    }

    useEffect(() => {
        if (moliendaContext != null) {
            setInitialValues({
                ...initialValues,
                equipoMolienda: equipoMolienda,
                procesos: moliendaContext.procesos,
                largo: moliendaContext.superficie?.data?.largo,
                ancho: moliendaContext.superficie?.data?.ancho,
                area: moliendaContext.superficie?.data?.area
            })
        } else {
            setInitialValues({
                ...initialValues,
                equipoMolienda: equipoMolienda,
            })
        }
    }, [equipoMolienda])

    const handleNuevoEquipo = (valores) => {

        let equipoSeleccionado = tipoequipo.filter((t) => valores.tipo == t.idelemento)

        setequipoMolienda([...equipoMolienda, {
            cantidad: valores.cantidad,
            capacidad: valores.capacidad,
            condicion: valores.condicion,
            descripcion: valores.descripcion,
            elemento: {
                idelemento: valores.tipo,
                tipoOtros: valores.tipoOtros,
                nombreelemento: equipoSeleccionado[0].elemento.nombreelemento
            },
            //idanexocliente: 1,
            //iddataelemntocliente: 1,
            //idseccion: 1,
            otro: null
        }])

        handleCloseModalNuevoEquipo();
    }

    const handleEliminarEquipo = (elemento) => {
        let nuevoEquipo = equipoMolienda.filter((equipo) => equipo !== elemento);
        setequipoMolienda(nuevoEquipo);
    }

    const modalNuevoEquipo = () => {
        return (
            <div>
                <Modal
                    open={openModalNuevoEquipo}
                    onClose={handleCloseModalNuevoEquipo}
                    aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description"
                >
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            <div style={{ textAlign: "center" }}>
                                Nuevo Equipo
                            </div>
                        </Typography>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 2 }}>
                            <Formik
                                initialValues={informacionFormikModal}
                                onSubmit={(valores) => {
                                    handleNuevoEquipo(valores)
                                }}
                            >
                                {(props) => (
                                    <Form>
                                        <div className='table-responsive'>
                                            <table className='table table-striped table-hover'>
                                                <thead>
                                                    <tr>
                                                        <th>Tipo</th>
                                                        <th>Cantidad</th>
                                                        <th>Capacidad (ton)</th>
                                                        <th>Descripción y/o características</th>
                                                        <th width="120">Condición</th>
                                                        {
                                                            //<th>Largo (m)</th>
                                                            //<th>Ancho (m)</th>
                                                            //<th>Área (m²)</th>
                                                        }
                                                    </tr>
                                                </thead>

                                                <tbody>
                                                    <tr>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="tipo"
                                                                name="tipo"
                                                                className="form-select"
                                                                multiple={false}
                                                                required
                                                            >
                                                                <option defaultValue>Seleccione Tipo de Equipo</option>
                                                                {tipoequipo.map((t, index) => (
                                                                    <option key={index} value={t.idelemento}>{t.elemento.nombreelemento}</option>
                                                                ))}
                                                            </Field>
                                                            {
                                                                props.values.tipo === "4" ?
                                                                    <div>
                                                                        <br />
                                                                        <label htmlFor='tipoOtros'>Tipo de equipo:</label>
                                                                        <Field
                                                                            type="text"
                                                                            id="tipoOtros"
                                                                            name="tipoOtros"
                                                                            className="form-control form-control-sm"
                                                                        />
                                                                    </div>
                                                                    : <div></div>
                                                            }
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name="cantidad" placeholder="Cantidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name="capacidad" placeholder="Capacidad" required /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name="descripcion" placeholder="Descripción" required /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name="condicion"
                                                                className="form-select"
                                                                multiple={false}
                                                                required

                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {
                                                            //<td><Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" onChange={handleObtenerLargo} value={superficie.largo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" onChange={handleObtenerAncho} value={superficie.ancho} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={superficie.area} required /></td>
                                                        }
                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                        <div style={{ textAlign: "center" }}>
                                            <button type='submit' className="btn btn-success">GUARDAR</button>
                                        </div>
                                    </Form>
                                )}
                            </Formik>
                        </Typography>
                        <br />

                    </Box>
                </Modal>
            </div>
        )
    }

    return (
        <Fragment>
            <Formik
                initialValues={initialValues}
                enableReinitialize={true}
                validate={(valores) => {

                    const sup = {
                        data: {
                            largo: parseFloat(valores.largo),
                            ancho: parseFloat(valores.ancho),
                            area: parseFloat(valores.largo * valores.ancho),
                            //idfi_25anexo: idanexo.idfi_25anexo,
                            idseccion: 2,
                        }
                    }

                    const moliendaContext = {
                        superficie: sup,
                        equipoMolienda: valores.equipoMolienda,
                        procesos: valores.procesos,
                        procesosPreguntas: procesosMolienda,
                        submit: false
                    }

                    setContextMolienda(moliendaContext)
                }}
                onSubmit={(valores) => {

                    try {

                        const sup = {
                            data: {
                                largo: parseFloat(valores.largo),
                                ancho: parseFloat(valores.ancho),
                                area: parseFloat(valores.largo * valores.ancho),
                                //idfi_25anexo: idanexo.idfi_25anexo,
                                idseccion: 2,
                            }
                        }
                        dispatch(insertSuperficie(sup))

                        if (valores.procesos.length > 0) {

                            procesos.map((p, index) => {

                                const data = {
                                    data: {
                                        //idfi_25anexo: idanexo.idfi_25anexo,
                                        comentarios: valores.procesos[index],
                                        idproceso: p.idproceso,
                                    }
                                }

                                dispatch(insertFi25Procesos(data))   //Anexo Up procesos

                            })

                        } else {
                            console.log("procesos vacio")
                        }

                        if (valores.equipoMolienda.length > 0) {

                            valores.equipoMolienda.map((e) => {

                                const equipoHistorial = {
                                    data: {
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        cantidad: parseInt(e.cantidad),
                                        capacidad: parseFloat(e.capacidad),
                                        descripcion: e.descripcion,
                                        condicion: e.condicion,
                                        verificado: true,
                                        //idfi_25anexo: idanexo.idfi_25anexo
                                    }
                                }

                                const dataElementoClienteHistorial = {
                                    data: {
                                        cantidad: parseInt(e.cantidad),
                                        descripcion: e.descripcion,
                                        otro: "",
                                        idelemento: parseInt(e.elemento.idelemento),
                                        tipootros: e.elemento.tipoOtros,
                                        idseccion: 2,
                                        iddataelementocliente: e.iddataelementocliente
                                    }
                                }



                                dispatch(insertEquipoHistorial(equipoHistorial))   //Equipo Historial
                                dispatch(insertDataElementoClienteHistorial(dataElementoClienteHistorial))   //Data Elemento Cliente Historial
                            })

                        } else {
                            console.log("vacio")
                        }

                        const moliendaContext = {
                            superficie: sup,
                            equipoMolienda: valores.equipoMolienda,
                            procesos: valores.procesos,
                            procesosPreguntas: procesosMolienda,
                            submit: true
                        }

                        setContextMolienda(moliendaContext)

                        Store.addNotification({
                            title: "Molienda",
                            message: "Guardada exitosamente!",
                            type: "success",
                            insert: "center",
                            container: "top-center",
                            animationIn: ["animate__animated", "animate__fadeIn"],
                            animationOut: ["animate__animated", "animate__fadeOut"],
                            dismiss: {
                                duration: 3000,
                                onScreen: true
                            }
                        });

                    } catch (error) {
                        console.log(error)
                    }

                }}
            >
                {({ values }) => (
                    <Form>
                        {/* <div className='row'>
                             <label className={`${estilos.labelUI_title} mb-2`}>MOLIENDA</label>
                        </div>
                        */}
                        <div className={`${estilos.labelUI} row mb-2`}>
                            <label className={`${estilos.labelUI} mb-2`}>Superficie:</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-3 mb-3">
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="largo">Largo (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="largo" name="largo" placeholder="Largo" required />
                            </div>
                            <div className="col-md-2 mb-3">
                                <label htmlFor="ancho">Ancho (m)</label>
                                <Field type="text" className="form-control form-control-sm" id="ancho" name="ancho" placeholder="Ancho" required />
                            </div>

                            <div className="col-md-2 mb-3">
                                <label htmlFor="area">Área (m²)</label>
                                <Field type="text" className="form-control form-control-sm" id="area" name="area" placeholder="Área" value={values.largo * values.ancho} required />
                            </div>
                        </div>
                        <hr />
                        <div className='table-responsive'>
                            <table className='table table-striped table-hover'>
                                <thead>
                                    <tr>
                                        <th>Tipo</th>
                                        <th>Cantidad</th>
                                        <th>Capacidad (kg)</th>
                                        <th>Descripción y/o características</th>
                                        <th width="120">Condición</th>
                                        {
                                            //<th>Largo (m)</th>
                                            //<th>Ancho (m)</th>
                                            //<th>Área (m)</th>
                                        }
                                        <th>Acciones</th>
                                        <th>Validar</th>
                                    </tr>
                                </thead>
                                <FieldArray
                                    name='equipoMolienda'
                                    render={arrayHelpers => (
                                        <tbody>
                                            {equipoMolienda &&
                                                equipoMolienda.map((equipo, index) => (
                                                    <tr key={index}>
                                                        <td>
                                                            {equipo.elemento.nombreelemento}
                                                            <h6>{equipo.elemento.tipoOtros}</h6>
                                                        </td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="cantidad" name={`equipoMolienda.${index}.cantidad`} placeholder="Cantidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="capacidad" name={`equipoMolienda.${index}.capacidad`} placeholder="Capacidad" required disabled={editarEquipo} /></td>
                                                        <td><Field type="text" className="form-control form-control-sm" id="descripcion" name={`equipoMolienda.${index}.descripcion`} placeholder="Descripción" required disabled={editarEquipo} /></td>
                                                        <td>
                                                            <Field
                                                                component="select"
                                                                id="condicion"
                                                                name={`equipoMolienda.${index}.condicion`}
                                                                className="form-select"
                                                                multiple={false}
                                                                disabled={editarEquipo}
                                                            >
                                                                <option defaultValue>Seleccione Condicion</option>
                                                                <option value={"Buena"}>Buena</option>
                                                                <option value={"Regular"}>Regular</option>
                                                                <option value={"Mala"}>Mala</option>
                                                            </Field>
                                                        </td>
                                                        {
                                                            //<td><Field type="text" className="form-control form-control-sm" id="largo" name={`equipoMolienda.${index}.largo`} placeholder="Largo" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="ancho" name={`equipoMolienda.${index}.ancho`} placeholder="Ancho" disabled={editarEquipo} required /></td>
                                                            //<td><Field type="text" className="form-control form-control-sm" id="area" name={`equipoMolienda.${index}.area`} placeholder="Área" value={superficie.area} disabled={editarEquipo} required /></td>
                                                        }
                                                        <td><button type="button" className='btn btn-warning btn-sm' onClick={() => handleModificar()}>Modificar</button> <hr /> <button type="button" className='btn btn-danger btn-sm' onClick={() => handleEliminarEquipo(equipo)}>Eliminar</button></td>
                                                        <td><Field className="form-check-input" type="checkbox" name={`equipoMolienda.${index}.validar`} id="validar" /></td>
                                                    </tr>
                                                ))}
                                        </tbody>
                                    )}
                                />
                            </table>
                        </div>
                        <br />
                        <div style={{ textAlign: "center" }}>
                            <button type="button" className={`btn ${estilos.botonCircular}`} onClick={handleOpenModalNuevoEquipo}>+ </button> Añadir nuevo equipo
                        </div>
                        <br />
                        <div className='row'>
                            <label className={`${estilos.labelUI} mb-2`}>MÉTODO</label>
                        </div>
                        <div className='row'>
                            <div className="col-md-4 mb-3">
                                <label htmlFor="">PROCESO</label>
                            </div>
                            <div className="col-md-8 mb-3">
                                <label htmlFor="">DESCRIPCIÓN</label>
                            </div>
                        </div>
                        <FieldArray
                            name='procesos'
                            render={arrayHelpers => (
                                <div>
                                    {procesos.map((p, index) => (
                                        <div key={index}>
                                            <div className='row'>
                                                <div className="col-md-4 mb-3">
                                                    <label htmlFor={`proceso.${index}`}>{p.descripcion}</label>
                                                </div>
                                                <div className="col-md-8 mb-3">
                                                    <Field type="text" className="form-control form-control-sm" id={`procesos.${index}`} name={`procesos.${index}`} placeholder={p.descripcion} required />
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            )}
                        />
                        {
                            //<div className="row mb-5">
                            //    <div className="col ">
                            //        <button className={`btn ${estilos.botonVerdeCOMERCAM}`} type='submit'>GUARDAR</button>
                            //    </div>
                            //
                            //</div>
                        }
                    </Form>
                )}
            </Formik>
            <div>
                {modalNuevoEquipo()}
            </div>
        </Fragment>
    );
};


export default withRouter(MoliendaFormComponent)
